/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { City } from '@app/settings/cities/cities.model';
import { Industry } from '@app/settings/industries/industries.model';
import { Contact } from '@app/shared/components/contact/contact.model';
import { ContactPerson } from '@app/shared/components/contact-person/contact-person.model';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';
import { Country } from '@app/settings/countries/countries.model';
import { Locale } from '@app/settings/locales/locales.model';
import { Type } from '@app/settings/types/types.model';
import { ContactTypes } from '@app/shared/components/contact/contact-types.enum';

export class Client extends Model {
  id: number;
  name: string;
  description: string;
  address: string;
  vat_number: string;
  responsible_person: string;
  type_id: number;
  type?: Type;
  city_id: number;
  city?: City;
  country_id: number;
  country?: Country;
  industry_id: number;
  industry?: Industry;
  contacts: Array<Contact>;
  contact_persons: Array<ContactPerson>;
  bank_accounts: Array<BankAccount>;
  timezone: string;
  locales: Array<Locale>;
  tags: Array<string>;
  active: boolean;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.type) {
      this.type = new Type().deserialize(input.type);
    }

    return this;
  }

  get clientEmails(): Array<string> {
    const emails: Array<string> = [];
    if (this.contacts.length > 0) {
      this.contacts.forEach((contact: Contact) => {
        if (contact.type_id === ContactTypes.EMAIL) {
          emails.push(contact.value);
        }
      });
    }

    if (this.contact_persons.length > 0) {
      this.contact_persons.forEach((contactPerson: ContactPerson) => {
        if (contactPerson.contacts.length > 0) {
          contactPerson.contacts.forEach((contact: Contact) => {
            if (contact.type_id === ContactTypes.EMAIL) {
              emails.push(contact.value);
            }
          });
        }
      });
    }
    return emails;
  }
}
